import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mb-3 flex flex-wrap items-start justify-between gap-3"
};
const _hoisted_2 = {
  key: 0,
  class: "status-badge is-orange"
};
const _hoisted_3 = {
  key: 1,
  class: "mb-4 rounded-lg border border-orange-200 bg-orange-50 px-3 py-2 text-sm text-orange-700"
};
const _hoisted_4 = {
  class: "space-y-4"
};
import { computed, nextTick, ref, watch } from 'vue';
import ReportCommentPanel from './ReportCommentPanel.vue';
import ReportEvaluationSummary from './ReportEvaluationSummary.vue';
export default {
  __name: 'ReportFeedbackSection',
  props: {
    report: {
      type: Object,
      default: null
    },
    canComment: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    },
    focusCommentId: {
      type: [String, Number],
      default: ''
    },
    focusTarget: {
      type: String,
      default: ''
    }
  },
  emits: ['comment'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const evaluationSectionRef = ref(null);
    const commentsSectionRef = ref(null);
    const comments = computed(() => Array.isArray(props.report?.comments) ? props.report.comments : []);
    const evaluations = computed(() => Array.isArray(props.report?.evaluations) ? props.report.evaluations : []);
    const statusSummary = computed(() => props.report?.statusSummary || {});
    const containerClass = computed(() => props.embedded ? 'space-y-4' : 'rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm sm:px-5');
    const normalizedFocusTarget = computed(() => {
      if (props.focusTarget === 'evaluation') return 'evaluation';
      if (props.focusTarget === 'comments') return 'comments';
      return props.focusCommentId ? 'comments' : '';
    });
    const evaluationSectionClass = computed(() => normalizedFocusTarget.value === 'evaluation' ? 'rounded-xl ring-2 ring-blue-200 ring-offset-2 ring-offset-white' : '');
    watch(() => [normalizedFocusTarget.value, comments.value.length, evaluations.value.length, props.focusCommentId], () => scrollFocusedFeedbackTargetIntoView(), {
      immediate: true
    });
    function scrollFocusedFeedbackTargetIntoView() {
      nextTick(() => {
        if (normalizedFocusTarget.value === 'evaluation') {
          evaluationSectionRef.value?.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
          return;
        }
        if (normalizedFocusTarget.value === 'comments' && !props.focusCommentId) {
          commentsSectionRef.value?.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
        }
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", {
        class: _normalizeClass(containerClass.value)
      }, [!__props.embedded ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", null, [_createElementVNode("h2", {
        class: "text-base font-semibold text-slate-900"
      }, "评价与反馈"), _createElementVNode("p", {
        class: "mt-0.5 text-sm text-slate-500"
      }, "查看接收人对这份日报的评价、评论与补充要求。")], -1)), statusSummary.value?.supplementRequested ? (_openBlock(), _createElementBlock("span", _hoisted_2, "待补充")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), statusSummary.value?.supplementRequested ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 接收人要求补充日报，请查看下方反馈并补充总结内容。 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        ref_key: "evaluationSectionRef",
        ref: evaluationSectionRef,
        class: _normalizeClass(["scroll-mt-4 transition-shadow duration-200", evaluationSectionClass.value]),
        "data-feedback-section": "evaluation"
      }, [_createVNode(ReportEvaluationSummary, {
        evaluations: evaluations.value
      }, null, 8, ["evaluations"])], 2), _createElementVNode("div", {
        ref_key: "commentsSectionRef",
        ref: commentsSectionRef,
        class: "scroll-mt-4",
        "data-feedback-section": "comments"
      }, [_createVNode(ReportCommentPanel, {
        comments: comments.value,
        "can-submit": __props.canComment,
        "can-request-supplement": false,
        disabled: __props.submitting,
        "focus-comment-id": __props.focusCommentId,
        onSubmit: _cache[0] || (_cache[0] = $event => emit('comment', $event))
      }, null, 8, ["comments", "can-submit", "disabled", "focus-comment-id"])], 512)])], 2);
    };
  }
};